module.exports = __webpack_public_path__ + "img/mymovie.52f8dfd6.png";